import React, { useRef } from 'react';
import styles from './style.module.scss';

import Rounded from '../Projects/Test/common/RoundedButton';
import { useScroll, motion, useTransform } from 'framer-motion';
import Magnetic from '../Projects/Test/common/Magnetic';
import Background from '../assets/devshakilh/devshakilh.png'

export default function Index() {
  const container = useRef(null);
  const { scrollYProgress } = useScroll({
      target: container,
      offset: ["start end", "end end"]
  })
  const x = useTransform(scrollYProgress, [0, 1], [0, 100])
  const y = useTransform(scrollYProgress, [0, 1], [-500, 0])
  const rotate = useTransform(scrollYProgress, [0, 1], [120, 90])


  


  const formRef = useRef();



  return (
      <motion.div style={{ y }} ref={container} className={styles.contact}>
       
       
       <div className={styles.videoContainer}>
           {/* Persistent Background Video */}
          <video autoPlay loop muted className={styles.backgroundVideo}>
              <source src="/footer-video.mp4" type="video/mp4" />
               Your browser does not support the video tag.
            </video>
          </div>
          <div className={styles.body}>


              <div className={styles.title}>
                  <span>
                      <div className={styles.imageContainer}>
                          <img 
                              fill={true}
                              alt={"images"}
                              src={Background}
                          />
                      </div>
                      <h2>Let's work</h2>
                  </span>
                  <h2>together</h2>

                  <form
                      className="md:p-6 flex flex-col justify-center "
                    //   onSubmit={contactHandler}
                      ref={formRef}
                      data-aos="fade-up"
                      data-aos-anchor-placement="center-bottom"
                  > <div class="md:w-1/3">
                 
                </div>
             
     

  
                     
                      <div className="text-start">
                          <p
                          
                          >
                              <motion.div style={{ x }} className={styles.buttonContainer}>
                                  <Rounded backgroundColor={"#334BD3"} className={styles.button}>
                                      <p>Get in touch</p>
                                  </Rounded>
                              </motion.div>
                              <motion.svg style={{ rotate, scale: 2 }} width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M8 8.5C8.27614 8.5 8.5 8.27614 8.5 8L8.5 3.5C8.5 3.22386 8.27614 3 8 3C7.72386 3 7.5 3.22386 7.5 3.5V7.5H3.5C3.22386 7.5 3 7.72386 3 8C3 8.27614 3.22386 8.5 3.5 8.5L8 8.5ZM0.646447 1.35355L7.64645 8.35355L8.35355 7.64645L1.35355 0.646447L0.646447 1.35355Z" fill="white" />
                              </motion.svg>
                          </p>
                      </div>
                  </form>


              </div>
              <div className={styles.nav}>
                  <Rounded>
                      <p >  <a href="mailto:mdshakil6565a@gmail.com">mdshakil6565a@gmail.com</a></p>
                  </Rounded>
                  <Rounded>
                    
                      <p >  <a href="tel:+88 017 28 17 80 63">+88 017 28 17 80 63</a></p>
                  </Rounded>
              </div>
              <div className={styles.info}>
                  <div>
                      <span>
                          <h3>Version</h3>
                          <p>2023 © Edition</p>
                      </span>
                      <span>
                          <h3>Version</h3>
                          <p>11:49 PM GMT+2</p>
                      </span>
                  </div>
                  <div>
                      <span>
                          <h3>socials</h3>
                          <Magnetic>
                          <p>  <a href='https://www.github.com/devshakilh/'>GitHub</a></p>
                          </Magnetic>
                      </span>
                      <Magnetic>
                      <p>  <a href='https://www.linkedin.com/in/devshakilh/'>Linkedin</a></p>
                          
                      </Magnetic>
                      <Magnetic>
                        <p>  <a href='https://www.instagram.com/devshakilh/'>Instagram</a></p>
                      </Magnetic>
                      <Magnetic>
                        
                          <p><a href='https://www.facebook.com/devshakilh/'>Facebook</a></p>
                      </Magnetic>
                     
                  </div>
              </div>
          </div>
      </motion.div>
  )
}






//  import React, { useRef } from 'react';
//  import styles from './style.module.scss';
//  import { motion, useScroll, useTransform } from 'framer-motion';
 
//  export default function Index() {
//    const container = useRef(null);
//    const { scrollYProgress } = useScroll({
//      target: container,
//      offset: ['start end', 'end end'],
//    });
 
//    const y = useTransform(scrollYProgress, [0, 1], [-500, 0]);
 
//    return (
//      <motion.div style={{ y }} ref={container} className={styles.contact}>
//        <div className={styles.videoContainer}>
//          {/* Persistent Background Video */}
//          <video autoPlay loop muted className={styles.backgroundVideo}>
//            <source src="/footer-video.mp4" type="video/mp4" />
//            Your browser does not support the video tag.
//          </video>
//        </div>
 
//        <div className={styles.body}>
//          <div className={styles.title}>
//            <span>
//              <div className={styles.imageContainer}>
//                <motion.div className={styles.hoverContainer}>
//                  {/* Hover Background */}
//                  <img
//                    src="/bg-hover-image.webp"
//                    alt="Hover Background"
//                    className={styles.hoverBackground}
//                  />
//                </motion.div>
//                <h2>Let's work</h2>
//              </div>
//            </span>
//            <h2>together</h2>
//          </div>
 
//          <div className={styles.info}>
//            <div>
//              <span>
//                <h3>Socials</h3>
//                <p>
//                  <a href="https://www.github.com/devshakilh/">GitHub</a>
//                </p>
//              </span>
//              <span>
//                <p>
//                  <a href="https://www.linkedin.com/in/devshakilh/">LinkedIn</a>
//                </p>
//              </span>
//            </div>
//          </div>
//        </div>
//      </motion.div>
//    );
//  }
 